export const queue = []

const head = () => (queue.length ? queue[0] : null)

const dequeue = () => {
  const { closeListener } = head() || {}
  if (closeListener) closeListener()
  queue.shift()
}

const enqueue = val => {
  queue.push(val)
}

const isEmpty = () => queue.length === 0

export const modalQueue = {
  dequeue,
  enqueue,
  head,
  isEmpty,
}
